(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/helpers/tracking/toggle-corrects-tracking.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/helpers/tracking/toggle-corrects-tracking.js');
"use strict";

const analytics = svs.components.analytics;
const products = svs.utils.products;
const toggleCorrectsTracking = _ref => {
  let type = _ref.type,
    isToggleOn = _ref.isToggleOn,
    productId = _ref.productId;
  analytics.trackEvent({
    category: type,
    action: "".concat(isToggleOn ? 'automatic_correct' : 'manual_correct'),
    opt_label: "".concat(products.getDisplayName(productId))
  });
};
setGlobal('svs.components.tipsen.store.helpers.tracking.toggleCorrectsTracking', toggleCorrectsTracking);

 })(window);